var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        width: "15",
        height: "20",
        viewBox: "0 0 15 20"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Group_1755",
            "data-name": "Group 1755",
            transform: "translate(-1165.365 419.062)"
          }
        },
        [
          _c("path", {
            attrs: {
              id: "Path_592",
              "data-name": "Path 592",
              d:
                "M1179.084-410.463a3.345,3.345,0,0,0-1.811-.95v-3.1a4.414,4.414,0,0,0-1.331-3.214,4.41,4.41,0,0,0-3.214-1.331,4.415,4.415,0,0,0-3.215,1.331,4.414,4.414,0,0,0-1.331,3.214v3.1a3.339,3.339,0,0,0-1.811.95,3.347,3.347,0,0,0-1.006,2.43v5.6a3.345,3.345,0,0,0,1.006,2.43,3.346,3.346,0,0,0,2.43,1.007h7.853a3.349,3.349,0,0,0,2.43-1.007,3.346,3.346,0,0,0,1.006-2.43v-5.6A3.347,3.347,0,0,0,1179.084-410.463Zm-8.51-6.206a2.9,2.9,0,0,1,2.154-.893,2.9,2.9,0,0,1,2.153.892,2.9,2.9,0,0,1,.893,2.154v3.046h-6.093v-3.046A2.9,2.9,0,0,1,1170.574-416.669Zm8.017,14.238a1.829,1.829,0,0,1-.568,1.369,1.825,1.825,0,0,1-1.369.568H1168.8a1.824,1.824,0,0,1-1.369-.568,1.829,1.829,0,0,1-.568-1.369v-5.6a1.833,1.833,0,0,1,.568-1.37,1.834,1.834,0,0,1,1.369-.567h7.853a1.829,1.829,0,0,1,1.369.568,1.829,1.829,0,0,1,.568,1.369Z",
              fill: "#293ad3"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_593",
              "data-name": "Path 593",
              d:
                "M1172.728-407.157a.75.75,0,0,0-.75.75v2.35a.75.75,0,0,0,.75.75.75.75,0,0,0,.75-.75v-2.35A.75.75,0,0,0,1172.728-407.157Z",
              fill: "#293ad3"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }